import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "multiselect-multiple-label"
}
const _hoisted_2 = {
  key: 1,
  class: "multiselect-multiple-label"
}
const _hoisted_3 = {
  tabindex: "-1",
  class: "tagwidth-150 text-truncate"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{hstack: _ctx.isHorizontal}, "gap-2"])
  }, [
    _renderSlot(_ctx.$slots, "label"),
    _createVNode(_component_Multiselect, {
      id: _ctx.id,
      "model-value": _ctx.selectValue,
      class: _normalizeClass({
                'is-valid': _ctx.isComponentValid === true,
                'is-invalid': _ctx.isComponentValid === false,
                'is-invalid': !!_ctx.error,
            }),
      options: _ctx.selectItems,
      mode: _ctx.mode,
      "close-on-select": _ctx.closeOnSelect,
      label: 'label',
      rules: _ctx.getRules,
      searchable: true,
      "filter-results": true,
      strict: false,
      submit: false,
      disabled: _ctx.isDisabled,
      "disabled-prop": 'isDisabled',
      "native-support": true,
      "can-clear": _ctx.canClear,
      ref: "multiselect",
      "hide-selected": _ctx.hideSelected,
      "open-direction": _ctx.openDirection,
      autocomplete: "n/a",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChange($event))),
      onClear: _withModifiers(_ctx.handleClear, ["prevent"]),
      classes: {
                tag: 'text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1',
            }
    }, {
      beforelist: _withCtx(() => [
        (_ctx.includeShowAllOption)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleSelectAll($event)), ["prevent"]))
            }, " Select All "))
          : _createCommentVNode("", true)
      ]),
      multiplelabel: _withCtx(({values}) => [
        (values.length == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(values[0].label), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(values.length) + " items selected ", 1))
      ]),
      tag: _withCtx(({option, handleTagRemove, disabled}) => [
        _createElementVNode("div", {
          class: _normalizeClass(["multiselect-tag", {
                        'is-disabled': disabled,
                    }])
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-inlineblock hstack bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1" }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1),
          (!disabled)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "multiselect-tag-remove",
                onClick: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent"])
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "multiselect-tag-remove-icon" }, null, -1)
              ]), 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["id", "model-value", "class", "options", "mode", "close-on-select", "rules", "disabled", "can-clear", "hide-selected", "open-direction", "onClear"]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}